<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
  <mat-form-field class="input-field-date" fxFlex="120px">
    <input matInput [min]="min" [matDatepicker]="datepicker" [formControl]="dateFormControl" (dateChange)="onDateChange($event.value)" />
    <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
    <mat-datepicker #datepicker [disabled]="disabled"></mat-datepicker>
    <mat-error *ngIf="dateFormControl.hasError('matDatepickerParse')">{{ 'datetime-input.invalid_date' | translate }}</mat-error>
  </mat-form-field>

  <gt-time-input
    [parentForm]="parentForm"
    [required]="required"
    name="{{ name }}_time"
    [time]="time"
    (timeChange)="onTimeChange($event)"
    [disabled]="disabled"
  ></gt-time-input>
</div>
